import { render } from "./appFooter.vue?vue&type=template&id=60d2be0a"
const script = {}

import "./appFooter.vue?vue&type=style&index=0&id=60d2be0a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__